module.exports = __webpack_public_path__ + "static/media/documents.39a8a09f.svg";